import {
  debounce,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useMemo } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import NotificationToggleButton from "../NotificationToggleButton";

const TokenFilter = ({ filters, setFilters, liqOnDeployments, topic }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState("");
  const [contractStateType, setContractStateType] = useState("ALL");
  const [marketStateType, setMarketStateType] = useState("ALL");

  useEffect(() => {
    setFilters((prev) => {
      let query = searchParams.get("deployQuery");
      if (query) {
        setQuery(query);
        prev.query = query;
      }

      let contractState = searchParams.get("contractState");
      if (contractState) {
        setContractStateType(contractState);
        prev.contractState = contractState;
      }

      let marketState = searchParams.get("marketState");
      if (marketState) {
        setMarketStateType(marketState);
        prev.marketState = marketState;
      }

      return prev;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSearchParams((prev) => {
      if (query) prev.set("deployQuery", query);
      else prev.delete("deployQuery");
      if (contractStateType && contractStateType !== "ALL")
        prev.set("contractState", contractStateType);
      else prev.delete("contractState");
      if (marketStateType && marketStateType !== "ALL")
        prev.set("marketState", marketStateType);
      else prev.delete("marketState");
      return prev;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, contractStateType, marketStateType]);

  useEffect(() => {
    if (contractStateType && contractStateType !== "ALL")
      setFilters((prev) => ({ ...prev, contractState: contractStateType }));
    else setFilters((prev) => ({ ...prev, contractState: null }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractStateType]);

  useEffect(() => {
    if (marketStateType && marketStateType !== "ALL")
      setFilters((prev) => ({ ...prev, marketState: marketStateType }));
    else setFilters((prev) => ({ ...prev, marketState: null }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketStateType]);

  const setQueryDebounced = useMemo(
    () =>
      debounce((e) => {
        setFilters((prev) => ({ ...prev, query: e.target.value }));
      }, 500),
    [setFilters]
  );

  return (
    <Grid2
      container
      sx={{ padding: 2, marginBottom: 1, width: "100%" }}
      spacing={2}
    >
      <Grid2 container size={{ xs: 12, sm: 12, md: 6, lg: 5, xl: 5 }}>
        <Grid2 size={"grow"}>
          <TextField
            sx={{ width: "100%" }}
            size="small"
            variant="outlined"
            label="Search"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setQueryDebounced(e);
            }}
          />
        </Grid2>
        <Grid2 size={"auto"} sx={{ display: { md: "none" } }}>
          <NotificationToggleButton topic={topic || "TOKEN"} />
        </Grid2>
      </Grid2>
      <Grid2 size={{ xs: 6, sm: 6, md: 2, lg: 2 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Contract State</InputLabel>
          <Select
            value={contractStateType}
            label="Contract State"
            size="small"
            onChange={(e) => setContractStateType(e.target.value)}
          >
            <MenuItem value={"ALL"}>All</MenuItem>
            <MenuItem value={"PENDING"}>Pending</MenuItem>
            <MenuItem value={"DROPPED"}>Dropped</MenuItem>
            <MenuItem value={"CONFIRMED"}>Confirmed</MenuItem>
            <MenuItem value={"CODE_VERIFIED"}>Code Verified</MenuItem>
            <MenuItem value={"TOKEN_SOCIALS"}>Socials</MenuItem>
          </Select>
        </FormControl>
      </Grid2>
      <Grid2 size={{ xs: 6, sm: 6, md: 2, lg: 2 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Market State</InputLabel>
          <Select
            value={marketStateType}
            label="Market State"
            size="small"
            onChange={(e) => setMarketStateType(e.target.value)}
          >
            <MenuItem value={"ALL"}>All</MenuItem>
            <MenuItem disabled={liqOnDeployments} value={"NO_LIQUIDITY"}>
              No Liquidity
            </MenuItem>
            <MenuItem value={"LIQUIDITY"}>Liquidity</MenuItem>
          </Select>
        </FormControl>
      </Grid2>
      <Grid2 size={"grow"} />
      <Grid2 size={"auto"} sx={{ display: { xs: "none", md: "block" } }}>
        <NotificationToggleButton topic={topic || "TOKEN"} />
      </Grid2>
    </Grid2>
  );
};

export default TokenFilter;
